"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldNestedList = exports.ModelMutatorNestedList = void 0;
const core_api_1 = require("@ikegps/core-api");
const collection_field_1 = require("../collection.field");
class ModelMutatorNestedList extends collection_field_1.ModelMutator {
    manual(newText) {
        if (newText == null || !Array.isArray(newText)) {
            this.state.setFieldValue(this.field.id, null);
            return;
        }
        const options = this.field.schema.findOptions(newText);
        if (options == null || options.length !== newText.length || options.length === 0) {
            this.state.setFieldValue(this.field.id, null);
            return;
        }
        this.state.setFieldValue(this.field.id, newText);
    }
    copy(from) {
        if (!from.hasValue()) {
            this.manual(null);
            return true;
        }
        const value = from.value;
        if (this.field.schema.findOptions(value) != null) {
            this.manual(value);
            return true;
        }
        return false;
    }
    //Copies values from another Nested List, but only those that exist in the current field's schema.
    truncatedCopy(from) {
        if (!from.hasValue()) {
            this.manual(null);
            return true;
        }
        const validValues = from.value.filter((v) => {
            const found = this.field.schema.findOptions([v]);
            return found && found.length === 1;
        });
        if (validValues.length > 0) {
            this.manual(validValues);
            return true;
        }
        return false;
    }
}
exports.ModelMutatorNestedList = ModelMutatorNestedList;
class CollectionModelFieldNestedList extends collection_field_1.CollectionModelField {
    static isNestedListField(f) {
        return f.schema.type === CollectionModelFieldNestedList.TYPE;
    }
    static parse(text) {
        if (typeof text !== 'string') {
            return null;
        }
        return text.split(' > ');
    }
    get Mutator() {
        if (this._Mutator == null) {
            this._Mutator = new ModelMutatorNestedList(this);
        }
        return this._Mutator;
    }
    get value() {
        return this.stateValue || [];
    }
    get displayValue() {
        return this.value.join(' > ');
    }
    get color() {
        for (const option of this.schema.options.values) {
            if (option.value === this.value[0]) {
                return option.color;
            }
        }
        return null;
    }
    hasValue() {
        return this.value.length > 0;
    }
}
exports.CollectionModelFieldNestedList = CollectionModelFieldNestedList;
CollectionModelFieldNestedList.TYPE = core_api_1.IkeFieldType.NESTED_LIST;
//# sourceMappingURL=nested.list.field.js.map